/* eslint-disable */

import Vue from 'vue';
import vhtml from 'vhtml-ui';
import App from './App.vue';

import 'src/utils/ajax';

Vue.use(vhtml);

new Vue({
    el: '#app',
    render: h => h(App)
});
